import { useRef, useEffect, useState } from 'react';

const areas = [
  'Freehold', 'Howell', 'Manalapan', 'Marlboro',
  'Colts Neck', 'Holmdel', 'Aberdeen', 'Matawan',
  'Jackson', 'Lakewood', 'Toms River', 'Old Bridge',
  'Sayreville', 'Red Bank', 'Asbury Park', 'Long Branch',
];

export default function ServiceAreas() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div
            style={{
              opacity: inView ? 1 : 0,
              transform: inView ? 'translateY(0)' : 'translateY(28px)',
              transition: 'opacity 0.7s ease, transform 0.7s ease',
            }}
          >
            <span className="section-tag mb-4 block">Where We Work</span>
            <h2 className="section-heading mb-6">
              Serving New Jersey Communities
            </h2>
            <p className="text-warm-gray text-base leading-relaxed mb-10">
              Based in Freehold, NJ, our team serves Monmouth County, Ocean County, and surrounding communities throughout central and northern New Jersey.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {areas.map((area, i) => (
                <div
                  key={area}
                  className="bg-white border border-cream-dark rounded-md px-3 py-2.5 text-center hover:border-gold/40 hover:bg-white transition-colors duration-200 cursor-default"
                  style={{
                    opacity: inView ? 1 : 0,
                    transition: `opacity 0.4s ease ${0.1 + i * 0.04}s`,
                  }}
                >
                  <p className="text-charcoal text-sm font-medium">{area}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 flex items-start gap-4 p-5 bg-white border border-cream-dark rounded-lg">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-charcoal flex-shrink-0">
                <i className="ri-map-pin-2-line text-gold text-base"></i>
              </span>
              <div>
                <p className="font-semibold text-charcoal text-sm mb-1">Our Base Location</p>
                <p className="text-warm-gray text-sm">8 Tuscan Dr, Freehold, NJ 07728</p>
                <a
                  href="https://maps.google.com/?q=8+Tuscan+Dr,+Freehold,+NJ+07728"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-gold text-xs font-semibold mt-1 inline-flex items-center gap-1 hover:underline"
                >
                  Get Directions <i className="ri-external-link-line text-xs"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right — Map */}
          <div
            className="rounded-lg overflow-hidden"
            style={{
              height: '480px',
              opacity: inView ? 1 : 0,
              transform: inView ? 'translateX(0)' : 'translateX(28px)',
              transition: 'opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s',
              boxShadow: '0 8px 40px rgba(44,44,44,0.1)',
            }}
          >
            <iframe
              title="Value Carpet Inc Location — Freehold NJ"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3042.0!2d-74.2756!3d40.2615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c18c95d7c6e281%3A0x8b5e0f0c7b3a4d9b!2s8+Tuscan+Dr%2C+Freehold%2C+NJ+07728!5e0!3m2!1sen!2sus!4v1680000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
